export default {
  formId: 'createCargoForm', //'checkoutForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre cargo*',
      requiredErrorMsg: 'El nombre cargo es requerido.',
    },
    description: {
      name: 'description',
      label: 'Descripcion*',
      requiredErrorMsg: 'La descripcion es requerida.',
    },
    area: {
      name: 'area',
      label: 'Area',
      requiredErrorMsg: 'El area es requerida.',
    },
    visita_domiciliaria: {
      name: 'visita_domiciliaria',
      label: 'visita domiciliaria',
      requiredErrorMsg: 'La visita domiciliaria es requerida.',
    },
    prueba_psicotecnica: {
      name: 'prueba_psicotecnica',
      label: 'prueba psicotecnica',
      requiredErrorMsg: 'La prueba psicotecnica es requerida.',
    },
    examen_alimentos: {
      name: 'examen_alimentos',
      label: 'examen alimentos',
      requiredErrorMsg: 'El examen alimentos es requerido.',
    },
    examen_alturas: {
      name: 'examen_alturas',
      label: 'examen de alturas',
      requiredErrorMsg: 'El examen de alturas es requerido.',
    },
    certificado_laboral: {
      name: 'certificado_laboral',
      label: 'certificado laboral',
      requiredErrorMsg: 'El certificado laboral es requerido.',
    },
    certificado_estudios: {
      name: 'certificado_estudios',
      label: 'certificado estudios',
      requiredErrorMsg: 'El certificado de estudios es requerido.',
    },
    adres: {
      name: 'adres',
      label: 'adres',
      requiredErrorMsg: 'El adres es requerido.',
    },
    antecedentes_judicial: {
      name: 'antecedentes_judicial',
      label: 'antecedentes judicial',
      requiredErrorMsg: 'Los antecedentes judiciales son requeridos.',
    },
    entrevista: {
      name: 'entrevista',
      label: 'entrevista',
      requiredErrorMsg: 'La entrevista es requerida.',
    },
    sociodemografica: {
      name: 'sociodemografica',
      label: 'sociodemografica',
      requiredErrorMsg: 'La sociodemografica es requerida.',
    },
    dme: {
      name: 'dme',
      label: 'dme',
      requiredErrorMsg: 'La dme es requerida.',
    },
    sst: {
      name: 'sst',
      label: 'sst',
      requiredErrorMsg: 'La sst es requerida.',
    },
  },
};
